/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { exportRatingsAnalytics } from 'state/actions/ratingsState/analyticsStatus';
// material
import { Title, Tip } from '@insticator/insticator-ui'; // iui-material
import ExportBox from 'material/exportbox/exportbox';
// utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/analytics/analytics_styles';



/* ========== ~~~~~~~~~~ RATINGS ANALYTICS ~~~~~~~~~~ ========== */
const Analytics = (props) => {

  const dispatch = useDispatch();

  const siteUUID = useSelector(state => state.ratingsState.configStatus.siteUUID);
  const isExporting = useSelector(state => state.ratingsState.analyticsStatus.isExporting);


  const csvMessages = [
    `Comma Separated Values (CSV) is a format that stores table and spreadsheet information. 
    The content is text, numbers, and dates in plain text. 
    Each line represents a row of the table, and commas separate the cells in a row.`,
    `CSV files can be opened by any spreadsheet program: Microsoft Excel, Open Office, Google Spreadsheets,
    etc. You can open a CSV file in a simple text editor as well.`
  ];

  const xmlMessages = [
    `Extensible Markup Language (XML) is a format that stores and describes information in plain text with custom tags. 
    XML files are reader-friendly, with a clear focus on use and exchange on the Internet and on corporate networks.`,
    'XML files can be opened by any web browser for viewing structured data or by Notepad for editing.'
  ];

  const applyTipMessages = (messages) => {
    return (
      <div className={'csvToolTip'}>
        <span>{messages[0]}</span>
        <br /><br />
        <span>{messages[1]}</span>
      </div>
    );
  }

  
  return(
    <div className={`analytics ${props.classes.analytics}`}>
      <div className={'header'}>
        <Title><h3>Export Events Analytics for Ratings in Your Site</h3></Title>
        <p>
          Export includes <strong>total ratings recorded</strong> and <strong>current average ratings</strong> for all pages
          with the <strong>Ratings Unit</strong> on it.
        </p>
      </div>

      <ExportBox 
        image={'illustration-csv.png'} 
        title={'Comma Separated Values'} 
        value={`csv`}
        subdescription={'Tabular format (Microsoft Excel, Google Spreadsheets, etc.).'} 
        buttontext={'Export as CSV'} 
        selected={isExporting}
        tipcontent={applyTipMessages(csvMessages)}
        handleExport={() => dispatch(exportRatingsAnalytics({format: 'csv', siteUUID}))} 
      /> 

      <ExportBox 
        image={'illustration-xml.png'} 
        title={'Extensible Markup Language'} 
        value={`xml`}
        subdescription={'Internet format (Web browsers, Notepad, etc.).'} 
        buttontext={'Export as XML'} 
        selected={isExporting}
        tipcontent={applyTipMessages(xmlMessages)}
        handleExport={() => dispatch(exportRatingsAnalytics({format: 'xml', siteUUID}))} 
      />
    </div>
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Analytics);
